import BoltIcon from "@mui/icons-material/Bolt";
import { type FC, type MouseEventHandler, useMemo } from "react";

import { FilterChip } from "~/components/UI/FilterChip";

interface ActivityFilter24hButtonProps {
  minVolumeLabel?: string | null;
  priceChangeLabel?: string | null;
  locked?: boolean;
  onOpen: MouseEventHandler<HTMLButtonElement>;
  onClear: () => void;
}

export const ActivityFilter24hButton: FC<ActivityFilter24hButtonProps> = ({
  minVolumeLabel,
  priceChangeLabel,
  locked,
  onOpen,
  onClear,
}) => {
  const valueLabel = useMemo(() => {
    const labels = [minVolumeLabel, priceChangeLabel].filter(Boolean);

    return labels.length > 0 ? labels.join(" · ") : undefined;
  }, [minVolumeLabel, priceChangeLabel]);

  return (
    <FilterChip
      label="24h"
      icon={<BoltIcon fontSize="inherit" />}
      valueLabel={valueLabel}
      locked={locked}
      onClick={onOpen}
      onClear={onClear}
    />
  );
};
